/**
 * Session 24 — OCPP 2.0.1 NotifyCustomerInformation outbound (CP → CSMS):
 * the paged reply to a CustomerInformation(report=true). Each page carries
 * a ≤512-char `data` chunk. v2.0.1-only.
 */
export interface NotifyCustomerInformationDomain {
  readonly requestId: number;
  readonly seqNo: number;
  readonly generatedAt: string;
  readonly tbc: boolean;
  readonly data: string;
}

export function buildNotifyCustomerInformationRequest(
  req: NotifyCustomerInformationDomain,
): Record<string, unknown> {
  return {
    requestId: req.requestId,
    seqNo: req.seqNo,
    generatedAt: req.generatedAt,
    tbc: req.tbc,
    data: req.data,
  };
}

const MAX_DATA_CHARS = 512;

/**
 * Chunk a report string into ≤512-char NotifyCustomerInformation pages with
 * incrementing seqNo and `tbc` (last page false). An empty string still
 * yields one terminating page.
 */
export function paginateNotifyCustomerInformation(
  requestId: number,
  report: string,
  generatedAt: string = new Date().toISOString(),
): readonly NotifyCustomerInformationDomain[] {
  const pages: NotifyCustomerInformationDomain[] = [];
  const chunks = report.length === 0 ? [''] : chunk(report, MAX_DATA_CHARS);
  chunks.forEach((data, i) => {
    pages.push({ requestId, seqNo: i, generatedAt, tbc: i < chunks.length - 1, data });
  });
  return pages;
}

function chunk(s: string, size: number): string[] {
  const out: string[] = [];
  for (let i = 0; i < s.length; i += size) out.push(s.slice(i, i + size));
  return out;
}
